<template>
  <router-view v-if="!authStore.loading" />
  <div v-else class="loading-screen">
    Loading...
  </div>
</template>

<script setup>
import { onBeforeMount } from 'vue';
import { useAuthStore } from './stores/useAuthStore';

const authStore = useAuthStore();

onBeforeMount(async () => {
  await authStore.fetchUser();
});
</script>

<style scoped>
.loading-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: sans-serif;
}
</style>

